export default "__VITE_ASSET__e65fa23e__"